import { render } from "./PreviousWork.vue?vue&type=template&id=59a87714&scoped=true"
import script from "./PreviousWork.vue?vue&type=script&lang=js"
export * from "./PreviousWork.vue?vue&type=script&lang=js"

import "./PreviousWork.vue?vue&type=style&index=0&id=59a87714&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a87714"]])

export default __exports__